<template>
    <div class="card-container">
        <div class="header-container">
            <span class="header-title">{{ headerTitle }}</span>
            <img :src="closeIcon" alt="close" class="close-icon" v-on:click="this.cancel" />
        </div>
        <div :style="{ maxHeight: contentMaxHeight }" class="card-content-container">
            <slot />
        </div>
        <BottomNavigation
            :back="back"
            :cancel="cancel"
            :confirm="this.confirm"
            :confirmButtonDisabled="!activeValidate"
            :first="first"
            :last="false"
            :next="confirm"
            :smallMarginRight="true"
            class="bottom-nav"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BottomNavigation from '../layout/BottomNavigation.vue';

export default defineComponent({
    components: { BottomNavigation },
    props: {
        headerTitle: { type: String, required: true },
        activeValidate: { type: Boolean, required: true },
        // Harmonisation de la taille avec ModalCard
        maxWidth: { type: String, required: false, default: '60%' },
        // Largeur fixe optionnelle (ex: '70vw' ou '1200px')
        width: { type: String, required: false, default: undefined },
        // Hauteur fixe optionnelle de la carte (ex: '80vh'). Le contenu scrolle à l'intérieur.
        height: { type: String, required: false, default: undefined },
        // Hauteur max du contenu défilant
        contentMaxHeight: { type: String, required: false, default: '25vh' },
        // Overflow du conteneur de contenu (ex: 'visible' pour les dropdowns)
        overflowContent: { type: String, required: false, default: 'auto' },
        // Largeur minimale optionnelle (ex: '900px')
        minWidth: { type: String, required: false, default: '650px' },
        // Afficher ou non le bouton précédent
        first: { type: Boolean, required: false, default: true },
        // Callback du bouton précédent
        back: { type: Function, required: false, default: undefined },
    },
    methods: {
        confirm() {
            this.$emit('confirm');
        },
        cancel() {
            this.$emit('cancel');
        },
    },
    computed: {
        closeIcon() {
            return require('@/assets/img/close-white.svg');
        },
    },
});
</script>

<style scoped>
.card-container {
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
    max-width: v-bind(maxWidth);
    width: v-bind(width);
    min-width: v-bind(minWidth);
    height: v-bind(height);
}
.card-content-container {
    padding: 16px;
    background-color: var(--white);
    overflow: v-bind(overflowContent);
    max-height: v-bind(contentMaxHeight);
}
.header-container {
    position: relative;
    padding: 12px 24px;
    background-color: var(--bleu-prinicipal);
}
.header-title {
    font-weight: var(--font-weight-normal);
    font-size: var(--font-size-large);
    color: var(--white);
}
.bottom-nav {
    position: relative;
    height: 55px;
    z-index: 999;
}
.close-icon {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
}
</style>
